import api from "@/api/api-v2-config";

export async function getTimesheetListAxios() {
  return await api.get("hrms/timesheet?pageNumber=1&pageSize=100000");
}

export async function getTimesheetIdAxios(id) {
  return await api.get("hrms/timesheet/" + id);
}

export async function getTimesheetbyStatusAxios(status) {
  return await api.get("hrms/timesheet/" + status);
}

export async function deleteTimesheetAxios(timesheet) {
  return await api.delete("hrms/timesheet/"+ timesheet);
}

export async function postTimesheetAxios(timesheet) {
  return await api.post("hrms/timesheet", timesheet);
}

export async function putTimesheetAxios(timesheet) {
  return await api.put("hrms/timesheet", timesheet);
}

export async function putTimesheetApprovalAxios(timesheet) {
  return await api.put("hrms/timesheet/approval", timesheet);
}
